import { TypographyH2 } from "@/components/ui/typography"
import modalStyles from "../modals.module.scss"
import { useRenameContentForm } from "./model"
import styles from "./styles.module.scss"
import { Button } from "@/components/ui/button"
import { Save } from "lucide-react"
import { useAutoTranslation, useModalStore } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS, LANG_KEYS } from "@/shared/constants"
import { Modal } from "@/shared/types"
import { Controller } from "react-hook-form"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useEffect, useRef } from "react"

interface Props {
  id: string
  title: string
}

export const RenameContentModal = ({ id, title }: Props) => {
  const { t } = useAutoTranslation()
  const handleClose = () => {
    useModalStore.getState().closeModal(Modal.RENAME_CONTENT)
  }

  const { control, handleSubmit, titleValue, isLoading } = useRenameContentForm(
    id,
    title,
    handleClose
  )
  const inputRef = useRef<HTMLInputElement>(null)

  const onBlur = () => {
    inputRef.current?.focus()
  }

  useEffect(() => {
    const handleInitForceFocus = async () => {
      for (let i = 0; i < 10; i++) {
        inputRef.current?.focus()
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    }

    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleClose()
      }
    }

    handleInitForceFocus()
    window.addEventListener("keydown", handleKeyPress)
    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [])

  return (
    <div className={modalStyles.backdrop} onClick={handleClose}>
      <div className={styles.wrapper}>
        <div className={styles.card} onClick={e => e.stopPropagation()}>
          <TypographyH2>
            {t(DISCOVERED_TRANSLATION_KEYS.RENAME_CONTENT)}
          </TypographyH2>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <Controller
              control={control}
              name="title"
              render={({ field }) => (
                <div className="flex flex-col gap-2">
                  <Label htmlFor="rename-content-title">
                    {t(DISCOVERED_TRANSLATION_KEYS.NEW_TITLE)}
                  </Label>
                  <Input
                    autoFocus
                    ref={inputRef}
                    onBlur={onBlur}
                    id="rename-content-title"
                    value={field.value}
                    onChange={field.onChange}
                    placeholder={t(DISCOVERED_TRANSLATION_KEYS.ENTER_NEW_TITLE)}
                    disabled={isLoading}
                  />
                </div>
              )}
            />
            <Button
              type="submit"
              disabled={!titleValue.trim()}
              isLoading={isLoading}
            >
              <Save />
              {t(LANG_KEYS.RENAME)}
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
